export default {
  spendField: 'spend_ltd',
  interpolateMonths: true,
  trendMetrics: [
    {
      metric: 100,
      field: 'adpi',
      label: 'Ad Effect Score',
      format: '.0f',
      scale: [80, 160]
    },
    {
      metric: 115,
      field: 'ease_of_branding',
      label: 'Ease of Branding',
      format: '.0%',
      scale: [0, 0.8]
    },
    {
      metric: 112,
      field: 'consideration',
      label: 'Lift to Consideration',
      format: '.0%',
      scale: [0, 0.6]

    },
    {
      metric: 101,
      field: 'impression',
      label: 'Lift to Impression',
      format: '.0%',
      scale: [0, 0.6]
    },
    {
      metric: 102,
      field: 'actions',
      label: 'Net Actions',
      format: '.0%',
      scale: [0, 0.6]
    }
  ]
};



// WEBPACK FOOTER //
// ./src/app/configuration/Max/config/components/scorecard/Trendchart/index.js